<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <Form ref="secteurForm" @submit="addSecteur" :validation-schema="secteurSchema">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Libellé <span class="text-danger">*</span>
              </label>
              <Field name="libelle" type="text" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Entrez le libellé du secteur" />
              <ErrorMessage name="libelle" class="text-danger" />
            </div>
          </div>
          <!-- <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Statut
              </label>
              <div class="form-check">
                <Field name="statut" type="checkbox" :value="true" class="form-check-input" id="statut" />
                <label class="form-check-label text-black fw-semibold" for="statut">
                  Actif
                </label>
              </div>
            </div>
          </div> -->
          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Description <span class="text-danger">*</span>
              </label>
              <Field name="description" as="textarea" rows="3" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Entrez la description du secteur" />
              <ErrorMessage name="description" class="text-danger" />
            </div>
          </div>
          <div class="col-md-8">
            <div class="d-flex align-items-center">
              <button class="default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success"
                type="submit">
                Ajouter
              </button>
              <router-link to="/liste-secteuractivites"
                class="btn btn-danger transition border-0 lh-1 fw-medium">
                <i class="flaticon-delete lh-1 me-1 position-relative top-2"></i>
                Annuler
              </router-link>
            </div>
          </div>
        </div>
      </Form>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import * as Yup from "yup";
import { useRouter } from "vue-router";
import Swal from "sweetalert2";
import ApiService from "../../services/ApiService";

export default defineComponent({
  name: "AddSecteurActivite",
  components: {
    Form,
    Field,
    ErrorMessage,
  },
  setup: () => {
    const secteurSchema = Yup.object().shape({
      libelle: Yup.string().required("Le libellé est obligatoire"),
      description: Yup.string().required("La description est obligatoire"),
    });

    const secteurForm = ref<any>(null);
    const router = useRouter();

    const addSecteur = async (values: any, { resetForm }) => {
      try {
        // S'assurer que statut est un booléen
        values.statut = values.statut === true;
        const response = await ApiService.post("/secteuractivite", values);
        Swal.fire({
          title: "Secteur d'activité créé avec succès",
          icon: "success",
          draggable: true,
          confirmButtonText: "OK",
          timer: 1500,
        }).then(() => {
          resetForm();
          router.push("/liste-secteuractivites");
        });
        console.log("Secteur ajouté avec succès:", response.data);
      } catch (err: any) {
        console.error("Erreur lors de l'envoi :", err);
        Swal.fire({
          title: "Erreur lors de l'ajout du secteur d'activité",
          text: err.response?.data?.message || "Une erreur est survenue",
          icon: "error",
          draggable: true,
        });
      }
    };

    return {
      addSecteur,
      secteurSchema,
      secteurForm,
    };
  },
});
</script>
